import { createClient } from '@supabase/supabase-js';


// Use Expo's variable if available (for native), otherwise fall back to React's (for web)
const supabaseAnonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON || process.env.REACT_APP_SUPABASE_ANON || '';

// Dynamically build the Supabase URL from the anon key
const getSupabaseUrl = (anonKey: string): string => {
  if (!anonKey) {
    throw new Error('Supabase anon key environment variable is required (EXPO_PUBLIC_SUPABASE_ANON or REACT_APP_SUPABASE_ANON)');
  }
  
  try {
    // Basic base64 decoding that works in both Node and browser environments
    const payloadB64 = anonKey.split('.')[1];
    const decodedPayload = typeof atob === 'function' 
      ? atob(payloadB64) 
      : Buffer.from(payloadB64, 'base64').toString('utf-8');
      
    const payload = JSON.parse(decodedPayload);
    return `https://${payload.ref}.supabase.co`;
  } catch (error) {
    console.error('Failed to decode Supabase anon key:', error);
    throw new Error('Invalid Supabase anon key format');
  }
};

const supabaseUrl = getSupabaseUrl(supabaseAnonKey);

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
